import * as LINKS from './links';

export const MIN_SKELETON_DURATION = 2000;

export const MOBILE_STORES = [
  {
    value: 'ru',
    text: 'RuStore',
    keywords: ['android'],
    link: LINKS.RU_STORE_LINK,
  },
  {
    value: 'apple',
    text: 'App Store',
    keywords: ['iphone', 'ipad', 'ipod'],
    link: LINKS.APP_STORE_LINK,
  },
  {
    value: 'huawei',
    text: 'AppGallery',
    keywords: ['huawei', 'honor'],
    link: LINKS.APP_GALLERY_LINK,
  },
  {
    value: 'google',
    text: 'Google Play',
    keywords: [],
    link: LINKS.GOOGLE_PLAY_LINK,
  },
] as const;
